/**
 * House of Places — "You may also like" carousel.
 *
 * The track is a CSS scroll-snap carousel (`grid-auto-flow: 100%`), so nothing
 * here sizes or positions a card: the arrows scroll by exactly one card and the
 * counter reads back which one is in view.
 *
 * Also keeps each card's price label in step with the size the shopper picks.
 */
(function () {
  // Dawn's quick-add modal re-runs every script inside <product-info> each
  // time it opens; bind once per page so no listener fires twice.
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['recommend-slider']) return;
  yuklu['recommend-slider'] = true;

  function kur(root) {
    if (root.dataset.hopRecReady) return;
    root.dataset.hopRecReady = '1';
    var track = root.querySelector('[data-hop-rec-track]');
    if (!track) return;

    var nav = root.querySelector('[data-hop-rec-nav]');
    var kartlar = Array.prototype.slice.call(track.querySelectorAll('.hop-rec-card'));

    if (nav && kartlar.length > 1) {
      var prev = nav.querySelector('[data-hop-rec-prev]');
      var next = nav.querySelector('[data-hop-rec-next]');
      var sayac = nav.querySelector('[data-hop-rec-count]');

      // Which card is nearest the track's left edge. Read from positions rather
      // than scrollLeft / cardWidth so it stays right whatever the column width.
      function etkin() {
        var sol = track.getBoundingClientRect().left;
        var en = 0;
        var enYakin = Infinity;
        kartlar.forEach(function (kart, i) {
          var fark = Math.abs(kart.getBoundingClientRect().left - sol);
          if (fark < enYakin) {
            enYakin = fark;
            en = i;
          }
        });
        return en;
      }

      function git(i) {
        var hedef = kartlar[Math.max(0, Math.min(kartlar.length - 1, i))];
        if (!hedef) return;
        track.scrollTo({
          left: hedef.offsetLeft - kartlar[0].offsetLeft,
          behavior: 'smooth',
        });
      }

      function iki(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tazele() {
        var i = etkin();
        if (sayac) sayac.textContent = iki(i + 1) + ' / ' + iki(kartlar.length);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      prev.addEventListener('click', function () {
        git(etkin() - 1);
      });
      next.addEventListener('click', function () {
        git(etkin() + 1);
      });

      track.addEventListener('scroll', tazele, { passive: true });
      window.addEventListener('resize', tazele);
      tazele();
    } else if (nav) {
      // One recommendation: nothing to page through.
      nav.hidden = true;
    }

    // Keep the shown price in step with the chosen size.
    track.querySelectorAll('[data-hop-rec-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var card = select.closest('.hop-rec-card');
        var price = card && card.querySelector('[data-hop-rec-price]');
        var opt = select.selectedOptions[0];
        if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
        var add = card && card.querySelector('.hop-rec-card__add');
        if (add && opt) add.disabled = opt.disabled;
      });
    });
  }

  /* The slider arrives as its own section (sections/hop-recommendations),
     fetched ONCE through the Section Rendering API into the empty shell the
     product section leaves in the info column. It used to be rendered inside
     main-product, which Dawn re-renders on every variant change — so every
     frame or size click re-ran the recommendation Liquid and shipped it back
     in a 142 KB payload (~500 ms). Now a variant change never touches it.

     The fetched markup is cached: if Dawn swaps the info column and brings
     back an empty shell, it is refilled from memory, not the network. */
  var onbellek = null;
  // The request in flight. tara() runs again from the body observer while the
  // first response is still on its way, and the cache is only filled when it
  // lands — so every slot used to start a second, identical fetch (measured:
  // two hop-recommendations requests 1 ms apart on every page load).
  var bekleyen = null;

  function doldur(slot) {
    if (slot.firstElementChild) return;
    var koy = function (html) {
      if (slot.firstElementChild) return;
      var kap = document.createElement('div');
      kap.innerHTML = html;
      var blok = kap.querySelector('.hop-recommend');
      if (!blok) return;
      // The block's own settings, carried on the shell (main-product.liquid).
      var baslik = slot.getAttribute('data-heading');
      var baslikEl = blok.querySelector('.hop-recommend__title');
      if (baslik && baslikEl) baslikEl.textContent = baslik;
      var sinir = parseInt(slot.getAttribute('data-limit'), 10);
      if (sinir > 0) {
        blok.querySelectorAll('[data-hop-rec-track] > .hop-rec-card').forEach(function (kart, i) {
          if (i >= sinir) kart.remove();
        });
      }
      slot.appendChild(blok);
      kur(blok);
    };
    if (onbellek !== null) {
      koy(onbellek);
      return;
    }
    if (!bekleyen) {
      bekleyen = fetch(slot.getAttribute('data-url'))
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          onbellek = html;
          return html;
        });
    }
    bekleyen.then(koy).catch(function () {
      /* no recommendations is a quiet failure, not a broken page */
    });
  }

  function tara() {
    document.querySelectorAll('[data-hop-rec-slot]').forEach(doldur);
    document.querySelectorAll('.hop-recommend').forEach(kur);
  }

  tara();
  new MutationObserver(tara).observe(document.body, { childList: true, subtree: true });
})();
